/**
 * SignaturePad - Unterschriften-Komponente
 * Verwendet react-signature-canvas
 */

import React, { useRef, useState, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import {
  Box,
  Button,
  Paper,
  Typography
} from '@mui/material';
import {
  Delete as ClearIcon,
  Check as SaveIcon
} from '@mui/icons-material';

const SignaturePad = ({ onSave, initialSignature }) => {
  const sigCanvas = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);
  const [isSaved, setIsSaved] = useState(false);

  useEffect(() => {
    // Lade initiale Unterschrift falls vorhanden
    if (initialSignature && sigCanvas.current) {
      sigCanvas.current.fromDataURL(initialSignature);
      setIsEmpty(false);
      setIsSaved(true);
    }
  }, [initialSignature]);

  const handleClear = () => {
    sigCanvas.current?.clear();
    setIsEmpty(true);
    setIsSaved(false);
    onSave?.(null);
  };

  const handleSave = () => {
    if (sigCanvas.current && !isEmpty) {
      const dataUrl = sigCanvas.current.toDataURL('image/png');
      onSave?.(dataUrl);
      setIsSaved(true);
    }
  };

  const handleBegin = () => {
    setIsEmpty(false);
    setIsSaved(false);
  };

  const handleEnd = () => {
    // Auto-Save nach jedem Strich
    if (sigCanvas.current) {
      const dataUrl = sigCanvas.current.toDataURL('image/png');
      onSave?.(dataUrl);
      setIsSaved(true);
    }
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        backgroundColor: '#fafafa'
      }}
    >
      <Box
        sx={{
          border: '2px solid',
          borderColor: isSaved ? 'success.main' : isEmpty ? '#ccc' : 'primary.main',
          borderRadius: 2,
          backgroundColor: 'white',
          mb: 2,
          overflow: 'hidden'
        }}
      >
        <SignatureCanvas
          ref={sigCanvas}
          penColor="#000"
          canvasProps={{
            style: {
              width: '100%',
              height: 200,
              touchAction: 'none'
            }
          }}
          onBegin={handleBegin}
          onEnd={handleEnd}
        />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Button
          variant="outlined"
          color="error"
          startIcon={<ClearIcon />}
          onClick={handleClear}
          disabled={isEmpty}
          size="small"
        >
          Löschen
        </Button>

        {isSaved ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <SaveIcon color="success" />
            <Typography variant="body2" color="success.main">
              Unterschrift gespeichert
            </Typography>
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">
            Unterschreiben Sie im Feld oben
          </Typography>
        )}
      </Box>

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', mt: 2, textAlign: 'center' }}
      >
        Zeichnen Sie mit dem Finger oder der Maus
      </Typography>
    </Paper>
  );
};

export default SignaturePad;
